export default __webpack_public_path__ + "static/media/5.cb4ee21b.mp4";